module.exports = __webpack_public_path__ + "img/hand-spock.f16edcbe.svg";